<!-- Title -->
<div class="d-flex justify-content-between align-items-center mb-2">
  <h3
    class="text-main font-weight--400 my-3"
  >
    Filteren
  </h3>
  <button mat-icon-button (click)="sheet.dismiss('closed-by-user')">
    <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
  </button>
</div>
<!-- End title -->
<!-- Filters -->
<div class="d-flex flex-column gap-2 w-100">
  <div class="flex-1">
    <!-- Search -->
    <mat-form-field appearance="outline" class="w-100 no-subscript search-form-field">
      <mat-label>Zoek in titel, nummer, beschrijving...</mat-label>
      <input [formControl]="searchQueryInput" matInput placeholder="Zoek in titel, nummer, beschrijving" value="">
    </mat-form-field>
  </div>

  <!-- Neighbourhood -->
  <mat-form-field appearance="outline" class="no-subscript">
    <mat-label>Wijk</mat-label>
    <mat-select [compareWith]="compareById" [formControl]="neighbourhoodSelect" multiple>
      @for (neighbourhood of neighbourhoodList; track neighbourhood.id) {
        <mat-option [value]="neighbourhood">{{ neighbourhood.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Theme -->
  <mat-form-field appearance="outline" class="no-subscript">
    <mat-label>Thema</mat-label>
    <mat-select [compareWith]="compareById" [formControl]="storyThemeSelect" multiple>
      @for (storyTheme of storyThemeList; track storyTheme.id) {
        <mat-option [value]="storyTheme">{{ storyTheme.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Tag -->
  <mat-form-field appearance="outline" class="no-subscript">
    <mat-label>Trefwoord</mat-label>
    <mat-select [compareWith]="compareById" [formControl]="tagSelect" multiple>
      @for (tag of storyTagList; track tag.id) {
        <mat-option [value]="tag">{{ tag.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Story type filter -->
  <mat-button-toggle-group
    [formControl]="storyTypeInput"
    hideSingleSelectionIndicator
    name="fontStyle"
    aria-label="Story type filter"
    class="align-self-start"
  >
    <mat-button-toggle value="all">Alles</mat-button-toggle>
    <mat-button-toggle value="stories">Verhalen</mat-button-toggle>
    <mat-button-toggle value="projects">Projecten</mat-button-toggle>
  </mat-button-toggle-group>

  <!-- Active filter -->
  <mat-button-toggle-group
    [formControl]="activeInput"
    hideSingleSelectionIndicator
    name="fontStyle"
    aria-label="Active filter"
    class="align-self-start"
  >
    <mat-button-toggle value="all">Alles</mat-button-toggle>
    <mat-button-toggle value="active">Actief</mat-button-toggle>
    <mat-button-toggle value="non-active">Niet actief</mat-button-toggle>
  </mat-button-toggle-group>

  <!-- Reset -->
  <div class="d-flex align-items-center">
    <button class="w-100" mat-stroked-button (click)="clearFilters()">Wis filters</button>
  </div>
</div>
<!-- End filters -->
